import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    docManagementListLoading: false,
    docManagementListSuccess: null,
    docManagementListError: '',
    documentsListLoading: false,
    documentsListSuccess: null,
    documentsListError: '',
    getDocumentLoading: false,
    getDocumentSuccess: {},
    getDocumentError: '',
}

export const documentsSlice = createSlice({
    name: 'documents',
    initialState,
    reducers: {
        setDocManagementListLoading: (state, action) => {
            state.docManagementListLoading = true;
            state.docManagementListSuccess = null;
            state.docManagementListError = '';
        },
        setDocManagementListSuccess: (state, action) => {
            state.docManagementListLoading = false;
            state.docManagementListSuccess = action.payload;
            state.docManagementListError = '';
        },
        setDocManagementListError: (state, action) => {
            state.docManagementListLoading = false;
            state.docManagementListSuccess = null;
            state.docManagementListError = action.payload;
        },
        setDocumentsListLoading: (state, action) => {
            state.documentsListLoading = true;
            state.documentsListSuccess = null;
            state.documentsListError = '';
        },
        setDocumentsListSuccess: (state, action) => {
            state.documentsListLoading = false;
            state.documentsListSuccess = action.payload;
            state.documentsListError = '';
        },
        setDocumentsListError: (state, action) => {
            state.documentsListLoading = false;
            state.documentsListSuccess = null;
            state.documentsListError = action.payload;
        },
        setGetDocumentLoading: (state) => {
            state.getDocumentLoading = true;
            state.getDocumentSuccess = {};
            state.getDocumentError = '';
        },
        setGetDocumentSuccess: (state, action) => {
            state.getDocumentLoading = false;
            state.getDocumentSuccess = action.payload;
            state.getDocumentError = '';
        },
        setGetDocumentError: (state, action) => {
            state.getDocumentLoading = false;
            state.getDocumentSuccess = {};
            state.getDocumentError = action.payload;
        },
        resetDetails: (state, action) => {
            state.getDocumentSuccess = {};
        },
    },
})

export const {
    setDocManagementListLoading, setDocManagementListSuccess, setDocManagementListError,
    setDocumentsListLoading, setDocumentsListSuccess, setDocumentsListError,
    setGetDocumentLoading, setGetDocumentSuccess, setGetDocumentError,
    setActiveSubjectsSuccess,setActiveSubjectsError,
    resetDetails
} = documentsSlice.actions

export default documentsSlice.reducer;